module.exports = __webpack_public_path__ + "img/triangle_grey.50955ac7.svg";